var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip_container"},[_c('div',{staticClass:"content_container"},[_c('div',{staticClass:"tooltip_color_indicator",style:({'background': _vm.indicatorColor })}),_c('div',{staticClass:"tooltip_label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"tooltip_value"},[_vm._v(_vm._s(_vm.value.toFixed(2) + _vm.unitText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }